import { useLanguage } from "@/context/LanguageContext";
import { SearchBar } from "./SearchBar";
import { CategoryChip } from "./CategoryChip";
import { Link } from "react-router-dom";
import { blogListPath } from "@/lib/blog";

/**
 * Blog liste sayfasının hero'su — landing PageHero pattern'inde.
 * Title/subtitle dile göre.
 * Aktif kategori filtresi varsa highlight.
 */
export function BlogHero({
  title,
  subtitle,
  categories = [],
  activeCategorySlug = null,
  showSearch = true,
  initialSearch = "",
}) {
  const { lang, t } = useLanguage();

  return (
    <section className="relative pt-28 pb-12 sm:pt-32 sm:pb-16 bg-gradient-to-b from-sky-50/50 to-white overflow-hidden">
      {/* Subtle grid background (PageHero ile aynı pattern) */}
      <div
        className="absolute inset-0 opacity-40"
        style={{
          backgroundImage:
            "linear-gradient(to right, #f1f5f9 1px, transparent 1px), linear-gradient(to bottom, #f1f5f9 1px, transparent 1px)",
          backgroundSize: "4rem 4rem",
        }}
      />
      {/* Sky orbs */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-sky-100/40 rounded-full blur-3xl -translate-y-1/3 translate-x-1/3 pointer-events-none" />

      <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-sky-50 border border-sky-200 mb-5">
          <div className="w-1.5 h-1.5 rounded-full bg-[#22A7D1] animate-pulse" />
          <span className="text-xs font-bold tracking-[0.15em] text-[#22A7D1]">
            {t("blog.overline")}
          </span>
        </div>

        <h1 className="text-3xl sm:text-4xl lg:text-5xl tracking-tighter font-black text-slate-900 leading-[1.1]">
          {title}
        </h1>

        {subtitle && (
          <p className="mt-5 text-base sm:text-lg leading-relaxed text-slate-500 max-w-2xl mx-auto">
            {subtitle}
          </p>
        )}

        {/* Search */}
        {showSearch && (
          <div className="mt-8 max-w-2xl mx-auto">
            <SearchBar lang={lang} initialValue={initialSearch} />
          </div>
        )}

        {/* Kategori chip'leri */}
        {categories.length > 0 && (
          <div className="mt-6 flex flex-wrap gap-2 justify-center">
            <Link
              to={blogListPath(lang)}
              className={`inline-flex items-center gap-1.5 text-xs font-bold px-3 py-1.5 rounded-full border transition-all hover:-translate-y-0.5 ${
                !activeCategorySlug
                  ? "bg-slate-900 text-white border-slate-900"
                  : "bg-white text-slate-600 border-slate-200 hover:border-slate-300"
              }`}
            >
              {t("blog.allPosts")}
            </Link>
            {categories.map((cat) => (
              <CategoryChip
                key={cat.id}
                name={cat.name}
                slug={cat.slug}
                color={cat.color}
                lang={lang}
                size="sm"
                active={activeCategorySlug === cat.slug}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
